// @flow
import type { Pet } from '@rover/react-lib/types';

const reactEmergencyContactContainer = '#js-emergency-form';

export type AppProps = {
  showfaq: boolean,
  conversationUrl: string,
  pets: Array<Pet>,
};

export const mount = (appProps: AppProps, id: string = reactEmergencyContactContainer) => {
  let ReactDOM;
  let renderRootElement;
  let EmergencyFormPageContainer;

  try {
    ReactDOM = require('react-dom');
    renderRootElement = require('../../../utils/renderRootElement').default;
    EmergencyFormPageContainer = require('./EmergencyFormPageContainer').default;
  } catch (e) {
    return () => {};
  }

  renderRootElement(EmergencyFormPageContainer, id, appProps);

  if (module.hot) {
    module.hot.accept('./EmergencyFormPageContainer', () => {
      renderRootElement(
        // eslint-disable-next-line global-require
        require('./EmergencyFormPageContainer').default,
        id,
        appProps
      );
    });
  }

  // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
  return () => ReactDOM.unmountComponentAtNode(document.querySelector(id));
};



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/index.js